// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Name-module--cls1--27RKQ","cls2":"styles-Name-module--cls2--1Ic64 styles-Name-module--cls1--27RKQ","vacancy":"styles-Name-module--vacancy--2ehle"};